import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-update-banner',
  imports: [IconComponent],
  templateUrl: './update-banner.component.html',
  styleUrl: './update-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateBannerComponent implements OnInit {
  private readonly swUpdate = inject(SwUpdate);
  private readonly destroyRef = inject(DestroyRef);

  public readonly updateAvailable = signal(false);
  public readonly message = signal('Er is een nieuwe versie beschikbaar.');

  public ngOnInit(): void {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.versionUpdates.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(evt => {
      if (evt.type === 'VERSION_READY') {
        this.updateAvailable.set(true);
      } else if (evt.type === 'VERSION_INSTALLATION_FAILED') {
        console.error('Installatie van nieuwe versie mislukt:', evt.error);
      }
    });

    // The SW reaches an unrecoverable state when files of the running version
    // are no longer on the server (e.g. removed by a deploy); only a reload fixes that.
    this.swUpdate.unrecoverable.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(evt => {
      console.error('Service worker in onherstelbare staat:', evt.reason);
      this.message.set('Er ging iets mis met de huidige versie. Vernieuw de pagina.');
      this.updateAvailable.set(true);
    });
  }

  public reload(): void {
    window.location.reload();
  }

  public dismiss(): void {
    this.updateAvailable.set(false);
  }
}
